export default __webpack_public_path__ + "static/media/teams_Footer_Bournemouth_Sponsorship.bee996d1.svg";